// Generated by Melange

import * as Buhta_components__TopLoadingBar from "../../../../../packages/components/src/atoms/TopLoadingBar.js";
import * as Buhta_landing__LoadingBar from "../../core/LoadingBar.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LoadingBarComponent(Props) {
  const match = Buhta_landing__LoadingBar.LoadingBarContext.useLoadingBar(undefined);
  const loadingBar = match[0];
  const match$1 = React.useState(function () {
    return /* Complete */ 1;
  });
  const setState = match$1[1];
  React.useEffect((function () {
    let exit = 0;
    switch (loadingBar) {
      case /* Start */ 0 :
        Curry._1(setState, (function (param) {
          return /* Start */ 0;
        }));
        break;
      case /* Complete */ 1 :
      case /* Off */ 2 :
        exit = 1;
        break;
    }
    if (exit === 1) {
      Curry._1(setState, (function (param) {
        return /* Complete */ 1;
      }));
    }
    
  }), [loadingBar]);
  return JsxRuntime.jsx(Buhta_components__TopLoadingBar.make, {
    color: "#FFE600",
    height: 3,
    state: match$1[0]
  });
}

const make = LoadingBarComponent;

export {
  make,
}
/* Buhta_components__TopLoadingBar Not a pure module */
